import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Disclosure } from '@headlessui/react'
import React from 'react'
import { MdDeleteOutline, MdOutlineModeEdit } from "react-icons/md";
import styles from '../../styles.module.scss'

const Template = ({ title, children, editOnClick,deleteOnClick}) => (
    <div>
      <Disclosure>
        {({ open }) => (
          <>
            <Disclosure.Button className={`${styles.templateHead} ${open ? 'selected' : ''}`}>
              {title}
              <div>
                {open && (
                  <>
                    {editOnClick && <MdOutlineModeEdit
                      size={20}
                      color="#9393AA"
                      className={styles.editIcon}
                      onClick={(e) => {
                        e.stopPropagation();
                        editOnClick()
                      }}
                    />}
                    {deleteOnClick && <MdDeleteOutline
                      size={20}
                      color="#9393AA"
                      className={styles.deleteIcon}
                      onClick={(e) => {
                        e.stopPropagation();
                        deleteOnClick()
                      }}
                    />}
                  </>
                )}
                <FontAwesomeIcon icon={open ? faMinus : faPlus} color="#9393AA" />
              </div>
            </Disclosure.Button>
            <Disclosure.Panel className={styles.templateBody}>
              {children}
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  )

export default Template
